import { withLDProvider } from 'launchdarkly-react-client-sdk';

export default function configureLaunchDarkly(
  App,
  launchDarklyAllFlagsState,
  launchDarklyClientSideId,
  railsEnv,
  launchDarklyContext,
  launchDarklySecureModeHash,
) {
  const testOptions = {
    streaming: false,
    sendEvents: false,
    fetchGoals: false,
  };

  return withLDProvider({
    clientSideID: launchDarklyClientSideId,
    context: launchDarklyContext,
    options: {
      ...(railsEnv === 'test' ? testOptions : {}),
      bootstrap: launchDarklyAllFlagsState,
      ...(launchDarklySecureModeHash ? { hash: launchDarklySecureModeHash } : {}),
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  })(App);
}
